import {
  Button,
  ButtonsWrapper,
  Form,
  Modal,
  SwitchInput,
  TextInput,
} from '@thinknet-gmbh/platform-common-ui';
import { DEFAULT_NAME_FIELD_REGEX } from '@thinknet-gmbh/platform-common';
import { useTranslation } from 'react-i18next';
import { useUpdateInternalMember } from 'src/hooks/members/update-internal-member.hook';

const EditUserModal = ({ onClose, selectedUser }: { onClose: () => void; selectedUser: any }) => {
  const { t } = useTranslation(['common', 'settings']);
  const [form] = Form.useForm();

  const { profile, account, _id } = selectedUser;

  const { editInternalMember, loading: updateLoading } = useUpdateInternalMember({
    onSuccess: onClose,
  });

  const onFinish = (values: any) => {
    const { additionalLocations, location, ...data } = values;

    editInternalMember({
      variables: {
        payload: { ...data, memberId: _id },
      },
    });
  };

  return (
    <Modal title={t('settings:userManagementSettings.editUser.title')} onClose={onClose} isOpened>
      <Form layout="vertical" onFinish={onFinish} form={form}>
        <Form.Item
          name="firstName"
          label={t('common:labels.firstName')}
          initialValue={profile.firstName}
          rules={[
            {
              required: true,
              message: t('common:validation.error.firstNameRequired'),
            },
            {
              pattern: DEFAULT_NAME_FIELD_REGEX,
              message: t('common:validation.error.incorrectFormat'),
            },
          ]}
        >
          <TextInput placeholder="Bill" maxLength={50} />
        </Form.Item>
        <Form.Item
          name="lastName"
          label={t('common:labels.lastName')}
          initialValue={profile.lastName}
          rules={[
            {
              required: true,
              message: t('common:validation.error.lastNameRequired'),
            },
            {
              pattern: DEFAULT_NAME_FIELD_REGEX,
              message: t('common:validation.error.incorrectFormat'),
            },
          ]}
        >
          <TextInput placeholder="Sanders" maxLength={50} />
        </Form.Item>
        <Form.Item
          name="email"
          label={t('common:labels.email')}
          initialValue={account.email}
          rules={[
            {
              required: true,
              message: t('common:validation.error.emailRequired'),
            },
            {
              type: 'email',
              message: t('common:validation.error.incorrectFormat'),
            },
          ]}
        >
          <TextInput placeholder="bill.sanders@gmail.com" maxLength={50} />
        </Form.Item>
        <Form.Item
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
          }}
          name="twoFA"
          label={t('settings:userManagementSettings.labels.twoFA')}
          valuePropName="checked"
          initialValue={account?.twoFA !== false ? true : false}
        >
          <SwitchInput
            style={{ marginLeft: '15px' }}
            checkedChildren={'On'}
            unCheckedChildren={'Off'}
            defaultChecked
          />
        </Form.Item>

        <ButtonsWrapper marginTop={16}>
          <Button type="primary" htmlType="submit" loading={updateLoading}>
            {t('common:buttons.save')}
          </Button>
          <Button onClick={onClose}>{t('common:buttons.cancel')}</Button>
        </ButtonsWrapper>
      </Form>
    </Modal>
  );
};

export default EditUserModal;
